import { IonButton, IonIcon } from '@ionic/react';
import {
  notifications,
  notificationsCircle,
  notificationsCircleOutline,
} from 'ionicons/icons';
import { FC } from 'react';

const NotificationBadgeButton: FC = ({ notificationCount }: any) => {
  return (
    <>
      <IonButton size='large' href='notifications'>
        <IonIcon
          icon={notificationsCircleOutline}
          className='w-8 h-8'
        ></IonIcon>
      </IonButton>
    </>
  );
};

export default NotificationBadgeButton;
